export default __webpack_public_path__ + "static/media/train.4420499c.mp3";